import { Sprint } from "../../types/sprint";

type SprintsByIdState = Record<string, Sprint>;

type SprintsByIdAction =
  | { type: "SET_SPRINTS"; payload: Record<string, Sprint> }
  | { type: "ADD_SPRINT"; payload: Sprint }
  | { type: "UPDATE_SPRINT"; payload: Sprint }
  | { type: "DELETE_SPRINT"; payload: { sprintId: string } }
  | { type: "CLEAR_SPRINTS" };

const sprintsById = (state: SprintsByIdState = {}, action: SprintsByIdAction): SprintsByIdState => {
  switch (action.type) {
    case "SET_SPRINTS": {
      // Replace all sprints (don't merge) to avoid stale data from other boards
      return action.payload;
    }
    case "ADD_SPRINT": {
      const sprint = action.payload;
      const id = sprint._id || sprint.id;
      if (!id) {
        console.warn("ADD_SPRINT: Sprint has no ID");
        return state;
      }
      return {
        ...state,
        [id]: { ...sprint, _id: id }
      };
    }
    case "UPDATE_SPRINT": {
      const sprint = action.payload;
      const id = sprint._id || sprint.id;
      if (!id) {
        console.warn("UPDATE_SPRINT: Sprint has no ID");
        return state;
      }
      return {
        ...state,
        [id]: { ...state[id], ...sprint, _id: id }
      };
    }
    case "DELETE_SPRINT": {
      const { sprintId } = action.payload;
      const { [sprintId]: deletedSprint, ...restOfSprints } = state;
      return restOfSprints;
    }
    case "CLEAR_SPRINTS": {
      return {};
    }
    default:
      return state;
  }
};

export default sprintsById;
